// @flow

import axios from "axios";
import camelcase from "camelize";
import snakecase from "snakecase-keys";
import config from "./config";
import { transformRequiredFields } from "@transformers/response";
import { PASSWORD_SET_PATH } from "./routes/constants";
import KeycloakAdapter from "./keycloak";
import LocalStorageService from "./services/LocalStorageService";
const localStorageService = LocalStorageService.getService();

axios.defaults.baseURL = config.endpointBaseUrl;
axios.defaults.timeout = 60000;
axios.defaults.header = { "Content-Type": "application/json" };

// Add a request interceptor
axios.interceptors.request.use(config => {
  if (KeycloakAdapter.isLoggedIn()) {
    const cb = () => {
      const staticPages = [PASSWORD_SET_PATH];
      const addToken = staticPages.filter(f => f !== window.location.pathname);
      let token = localStorageService.getAccessToken() || KeycloakAdapter.getToken();

      if (token && addToken.length) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (config.params) {
        config.params = snakecase(config.params);
      }

      if (config.data && config.headers["Content-Type"] !== "multipart/form-data") {
        if (Array.isArray(config.data)) {
          // Snakecase treat incomming data as Object
          config.data = config.data.map(item => snakecase(item));
        } else {
          config.data = snakecase(config.data);
        }
      }

      return Promise.resolve(config);
    };

    return KeycloakAdapter.updateToken(cb);
  }

  return config;
});

// Add a response interceptor
axios.interceptors.response.use(response => {
  const contentType = response.headers["content-type"] || "";

  if (
    !(response.data instanceof Blob) &&
    !(response.data instanceof ArrayBuffer) &&
    contentType.indexOf("text/csv") === -1
  ) {
    response.data = camelcase(response.data, { deep: true });
  }

  // For json schema to work correctly since we are
  // transforming the keys, we need to transform
  // the required params array as well.
  if (contentType === "application/json+schema") {
    response.data = transformRequiredFields(response.data);
  }

  return response;
});

export default axios;
